import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RouteGuard } from './route-guard';
import { ConfigIncidentTypeComponent } from './config-incident-type/config-incident-type.component';
import { RedirectGuard } from './redirect-guard';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'incidents',
    pathMatch: 'full'
  },
  {
    path: 'home',
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: environment.portalUrl
    }
  },
  {
    path: 'incidents',
    loadChildren: () => import('./incidents/incidents.module').then(m => m.IncidentsPageModule),
    canActivate: [RouteGuard]
  },
  {
    path: 'incident-types',
    loadChildren: () => import('./incident-types/incident-types.module').then(m => m.IncidentTypesPageModule),
    canActivate: [RouteGuard]
  },
  {
    path: 'incident/:id',
    loadChildren: () => import('./incident/incident.module').then(m => m.IncidentPageModule),
    canActivate: [RouteGuard],
  },
  {
    path: ':api/incident/:id/form/:formId/entry/:entryId',
    loadChildren: () => import('./incident-form/incident-form.module').then(m => m.IncidentFormPageModule)
  },
  {
    path: 'config/incident-type/:id',
    component: ConfigIncidentTypeComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./config-incident-type/incident-type/incident-type.module').then(m => m.IncidentTypePageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'optional-forms',
        loadChildren: () => import('./config-incident-type/incident-type-optional-forms/incident-type-optional-forms.module').then(m => m.IncidentTypeOptionalFormsPageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'workflow',
        loadChildren: () => import('./config-incident-type/incident-type-workflow/incident-type-workflow.module').then(m => m.IncidentTypeWorkflowPageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'notifications',
        loadChildren: () => import('./config-incident-type/incident-type-notifications/incident-type-notifications.module').then( m => m.IncidentTypeNotificationsPageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'permissions',
        loadChildren: () => import('./config-incident-type/incident-type-permissions/incident-type-permissions.module').then( m => m.IncidentTypePermissionsPageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'attributes',
        loadChildren: () => import('./config-incident-type/incident-type-attributes/incident-type-attributes.module').then( m => m.IncidentTypeAttributesPageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'versions',
        loadChildren: () => import('./config-incident-type/incident-type-versions/incident-type-versions.module').then( m => m.IncidentTypeVersionsPageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'integrations',
        loadChildren: () => import('./config-incident-type/incident-type-integrations/incident-type-integrations.module').then( m => m.IncidentTypeIntegrationsPageModule),
        canActivate: [RouteGuard]
      },
      {
        path: 'reports',
        loadChildren: () => import('./config-incident-type/incident-type-reports/incident-type-reports.module').then( m => m.IncidentTypeReportsPageModule),
        canActivate: [RouteGuard]
      },
],
  },
  {
    path: 'incident-form',
    loadChildren: () => import('./incident-form/incident-form.module').then(m => m.IncidentFormPageModule),
    canActivate: [RouteGuard]
  },
  {
    path: 'signature',
    loadChildren: () => import('./signature/signature.module').then(m => m.SignaturePageModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsPageModule),
    canActivate: [RouteGuard]
  },
  {
    path: 'map',
    loadChildren: () => import('./map/map.module').then( m => m.MapPageModule),
    canActivate: [RouteGuard]
  },
  {
    path: 'incident-restore',
    loadChildren: () => import('./incident-restore/incident-restore.module').then( m => m.IncidentRestorePageModule)
  },
  {
    path: 'user-select-modal',
    loadChildren: () => import('./user-select-modal/user-select-modal.module').then( m => m.UserSelectModalPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {paramsInheritanceStrategy: 'always'})
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
